import promise from 'promise';
import DispatchConstants from '../constants/DispatchConstants';
import ZillowSubscriptionStatusesByType from '../model/ZillowSubscriptionStatuses';
import api from '../utils/api';

const ZillowSubscriptionActions = {
    getSubscriptionStatus(subscriptionType) {
        return dispatch => dispatch(api.zillowSubscription.getSubscriptionStatus(subscriptionType))
            .then((result) => {
                if (result.success) {
                    const statusesByType = ZillowSubscriptionStatusesByType([result.response]);
                    return dispatch({
                        type: DispatchConstants.ZILLOW_SUBSCRIPTION_GET_SUCCESS,
                        payload: statusesByType,
                    });
                }
                return promise.reject(result.error);
            })
            .catch((errorRMWModel) => {
                console.error('ERROR @ZillowSubscriptionActions.getSubscriptionStatus: ', errorRMWModel.message);
            });
    },
    updateSubscriptionStatus(subscriptionType, enrolled) {
        return dispatch => dispatch(api.zillowSubscription.updateSubscriptionStatus(subscriptionType, enrolled))
            .then((result) => {
                if (result.success) {
                    return dispatch({
                        type: DispatchConstants.ZILLOW_SUBSCRIPTION_UPDATE_SUCCESS,
                        payload: {
                            subscriptionType,
                            isEmailable: enrolled,
                        },
                    });
                }
                return promise.reject(result.error);
            })
            .catch((errorRMWModel) => {
                console.error('ERROR @ZillowSubscriptionActions.updateSubscriptionStatus: ', errorRMWModel.message);
            });
    },
};

export default ZillowSubscriptionActions;
